import siteSetting from "./env";

export default {
    'HAIRDRESSER_SERVICES': siteSetting.api.v2 + "hairdresser/",
    // Rota writes are v2-only. The active location comes from the access
    // token; callers must never send a salonId that could drift from it.
    'HAIRDRESSER_ROTA_SAVE_V2': siteSetting.api.v2 + "hairdresser/",
    'HAIRDRESSER_WORKING_ROTA_SAVE_V2': siteSetting.api.v2 + "hairdresser/",
    'SALON_PROFILE': siteSetting.api.v2 + "salon/",
    'SALON_SERVICES': siteSetting.api.v2 + "salon/",
    'CLIENT_EDIT': siteSetting.api.v2 + "client/edit",
    'CLIENT_PROFILE': siteSetting.api.v2 + "client/profile",

    // Session endpoints are v2 (beu-node-v2 lib/module/v2/auth/sessionRoute.js).
    'LOGIN': siteSetting.api.v2 + "user/login",
    // v2 client signup — reconciles against salon-created accounts before
    // creating anything (beu-node-v2 docs/client-signup-reconciliation.md).
    'CLIENT_SIGNUP_V2': siteSetting.api.v2 + "user/client/signup",
    // Apple only: { code, state } from /redirect, or { identityToken } on iOS.
    'USER_SOCIAL_LOGIN': siteSetting.api.v2 + "user/socialLogin",
    'USER_FORGOT': siteSetting.api.v2 + "user/forgot",
    'USER_RESET': siteSetting.api.v2 + "user/reset",
    'SUBSCRIPTION_STATUS': siteSetting.api.v2 + "user/subscriptionStatus",
    // Partner Terms acceptance for the signed-in professional: has the CURRENT
    // published version been accepted? Drives the /welcome/partner-terms gate
    // for self-employed staff. Backend brief in PARTNER-TERMS-GATE.md.
    'PARTNER_TERMS_STATUS': siteSetting.api.v2 + "policy/partner_terms/status",
    'PARTNER_TERMS_ACCEPT': siteSetting.api.v2 + "policy/partner_terms/accept",
    'SET_FIRST_PASSWORD': siteSetting.api.v2 + "user/setFirstPassword",
    'USER_CHANGEPASSWORD': siteSetting.api.v2 + "user/changePassword",
    'SEND_SIGNUP_VERIFICATION_CODE': siteSetting.api.v2 + "user/sendSignupVerificationCode",
    'VERIFY_SIGNUP_CODE': siteSetting.api.v2 + "user/verifySignupCode",
    'RESET_PASSWORD_AND_LOGIN': siteSetting.api.v2 + "user/resetPasswordAndLogin",
    // v2 professional signup: SMS 2FA + account creation (replaces legacy)
    'PRO_SIGNUP_SEND_CODE': siteSetting.api.v2 + "user/signup/sendCode",
    'PRO_SIGNUP_VERIFY_CODE': siteSetting.api.v2 + "user/signup/verifyCode",
    'PRO_REGISTER': siteSetting.api.v2 + "user/register",
    'LINK_SUBSCRIPTION_BILLING': siteSetting.api.v2 + "user/linkSubscriptionBilling",

    'MAGIC_LINK_SEND': siteSetting.api.v2 + "magic-link/send-to-client",
    'MAGIC_LINK_CONSUME': siteSetting.api.v2 + "magic-link/consume",

    'PENDING_CLIENT_UPDATES_FOR_SALON_CLIENT': siteSetting.api.v2 + "pending-client-update/salon-client/",
    'PENDING_CLIENT_UPDATES_BY_CLIENT': siteSetting.api.v2 + "pending-client-update/by-client/",
    'PENDING_CLIENT_UPDATES_FOR_ME': siteSetting.api.v2 + "pending-client-update/me",
    'PENDING_CLIENT_UPDATE_ACCEPT': siteSetting.api.v2 + "pending-client-update/",
    'PENDING_CLIENT_UPDATE_DISMISS': siteSetting.api.v2 + "pending-client-update/",

    'USER_MERGE_PREVIEW': siteSetting.api.v2 + "user-merge/preview",
    'USER_MERGE_STATUS': siteSetting.api.v2 + "user-merge/status",
    'CLIENT_DUPLICATES': siteSetting.api.v2 + "client-duplicates",
    'USER_MERGE_CONFIRM': siteSetting.api.v2 + "user-merge/confirm",
    'USER_MERGE_ROLLBACK': siteSetting.api.v2 + "user-merge/",

    'USER_PROFILE': siteSetting.api.v2 + "user/profile",
    'LOGOUT': siteSetting.api.v2 + "user/logout/",

    'USER_CREATE_EVENT': "/events",

    'HAIRDRESSER_SWITCH_PROFILE':siteSetting.api.v2 + "user/switchProfile",

    // v2 salon search for the professional-signup picker (public, pre-auth).
    // Returns [{_id, salonName, formattedAddress, isClaimed}].
    'SALON_SEARCH_V2':siteSetting.api.v2 + "salon/search",

    'PAYMENT_ACTIVATATION_CODE': siteSetting.api.v2 + "payment/activationCode",
    'PAYMENT_SUBSCRIPTION_CHECKOUT': siteSetting.api.v2 + "payment/subscriptionCheckout",
    'PAYMENT_SUBSCRIPTION_RETRIEVE': siteSetting.api.v2 + "payment/subscriptionRetrieve",
    'PAYMENT_SUBSCRIPTION': siteSetting.api.v2 + "payment/subscription",
    'REQUEST_DEMO': siteSetting.api.v2 + "common/contactus",
    'BOOKING_PAYMENT': siteSetting.api.v2 + "payment/checkout",
    'BOOKING_PAYMENT_DONE': siteSetting.api.v2 + "payment/done",
    'MAKE_CUSTOMER_DEFAULT_CARD': siteSetting.api.v2 + "payment/cardCapureDone",
    'CHECK_EMAIL': siteSetting.api.v2 + "user/checkEmailExist",
    'PAYMENT_LIST':siteSetting.api.v2 + "payment/paymentList",

    'RESOURCE_LIST': siteSetting.api.v2 + "resource",
    'RESOURCE_GROUP': siteSetting.api.v2 + "resource/group",
    'RESOURCE_UNIT': siteSetting.api.v2 + "resource/unit",
    'RESOURCE_BOOKING_OPTIONS': siteSetting.api.v2 + "resource/booking-options",
    'RESOURCE_BOOKING_ASSIGNMENT': siteSetting.api.v2 + "resource/booking-assignment",
    'LIST_PRODUCT':siteSetting.api.v2 + "product/list-product",
    'GET_SALON_PRODUCT':siteSetting.api.v2 + "product/salon-product-list",
    'ADD_PRODUCT':siteSetting.api.v2 + "product/add-product",
    'UPDATE_PRODUCT':siteSetting.api.v2 + "product/update-product",
    'DELETE_PRODUCT':siteSetting.api.v2 + "product/delete-product",
    'GET_PRODUCT':siteSetting.api.v2 + "product/get-product",
    // Change a product's stock with a reason (STOCK_EDIT_VISIBLE; backend pending)
    'PRODUCT_STOCK_ADJUST':siteSetting.api.v2 + "product/stock-adjust",
    'LIST_PRODUCT_CATEGORIES':siteSetting.api.v2 + "product/list-categories",
    'LIST_PRODUCT_BRANDS':siteSetting.api.v2 + "product/list-brands",
    'ADD_PRODUCT_CATEGORY':siteSetting.api.v2 + "product/add-category",
    'DELETE_PRODUCT_CATEGORY':siteSetting.api.v2 + "product/delete-category",
    'ADD_PRODUCT_BRAND':siteSetting.api.v2 + "product/add-brand",
    'UPDATE_PRODUCT_BRAND':siteSetting.api.v2 + "product/update-brand",
    'DELETE_PRODUCT_BRAND':siteSetting.api.v2 + "product/delete-brand",
    'UPDATE_PRODUCT_CATEGORY':siteSetting.api.v2 + "product/update-category",
    'PRODUCT_CATEGORY_ORDERCHANGE':siteSetting.api.v2 + "product/category-order-change",
    'PRODUCT_ORDERCHANGE':siteSetting.api.v2 + "product/order-change",

    // Product commerce: sales orders, online checkout, store settings, reporting
    'PRODUCT_ORDERS':siteSetting.api.v2 + "product/orders",
    'PRODUCT_CHECKOUT':siteSetting.api.v2 + "product/checkout",
    'PRODUCT_STORE':siteSetting.api.v2 + "product/store",
    'PRODUCT_REPORTING':siteSetting.api.v2 + "product/reporting",
    'SERVICE_REPORTING':siteSetting.api.v2 + "service/reporting",

    'BANK_LINK':siteSetting.api.v2 + "payment/bankLink",
    'BANK_DETAIL':siteSetting.api.v2 + "payment/getBank",
    'BANK_ACCOUNT_DELETE':siteSetting.api.v2 + "payment/deleteBankAccount",
    'PAYOUT_LIST':siteSetting.api.v2 + "payment/payoutList",
    'PAYOUT':siteSetting.api.v2 + "payment/payout",
    'INSTANT_PAYOUT':siteSetting.api.v2 + "payment/instantPayout",
    // AI Concierge
    // Beu agent — the salon/SE side assistant (docs/agent-p0.md in beu-node-v2).
    // Every one of these is authenticated; there is no public path as there is
    // on the concierge, because this side reads the salon's own money.
    'AGENT_STATUS':siteSetting.api.v2 + "agent/status",
    'AGENT_APPEARANCE':siteSetting.api.v2 + "agent/appearance",
    'AGENT_CHAT':siteSetting.api.v2 + "agent/chat",
    'AGENT_SESSIONS':siteSetting.api.v2 + "agent/sessions",
    'AGENT_SETTINGS':siteSetting.api.v2 + "agent/settings",
    'AGENT_APPROVALS':siteSetting.api.v2 + "agent/approvals",
    'AGENT_GOALS':siteSetting.api.v2 + "agent/goals",
    'AGENT_ASKS':siteSetting.api.v2 + "agent/asks",
    'AGENT_DRAFTS':siteSetting.api.v2 + "agent/drafts",
    'AGENT_IDEAS':siteSetting.api.v2 + "agent/ideas",
    'AGENT_GLANCE':siteSetting.api.v2 + "agent/glance",
    'AGENT_PLAYBOOK':siteSetting.api.v2 + "agent/playbook",
    // The post studio's ask: stateless, no tools, no thread (docs/agent-p0.md §14)
    'AGENT_SOCIAL_ASK':siteSetting.api.v2 + "agent/social/ask",

    'CONCIERGE_STATUS':siteSetting.api.v2 + "concierge/status",
    'CONCIERGE_CHAT':siteSetting.api.v2 + "concierge/chat",
    'CONCIERGE_HISTORY':siteSetting.api.v2 + "concierge/history",
    'CONCIERGE_SETTINGS':siteSetting.api.v2 + "concierge/settings",
    'CONCIERGE_FAQ':siteSetting.api.v2 + "concierge/faq",
    'CONCIERGE_TRANSCRIPTS':siteSetting.api.v2 + "concierge/transcripts",
    'CONCIERGE_MESSAGES':siteSetting.api.v2 + "concierge/messages",
    'CONCIERGE_VOICE_NUMBER':siteSetting.api.v2 + "concierge/voice-number",
    'CONCIERGE_VOICE_NUMBER_OPTIONS':siteSetting.api.v2 + "concierge/voice-number/options",
    'CONCIERGE_VOICES':siteSetting.api.v2 + "concierge/voices",
    // Anomaly brake (hardening 2026-10): GET alerts (settings read), POST resume (owner only).
    'CONCIERGE_ALERTS':siteSetting.api.v2 + "concierge/alerts",
    'CONCIERGE_RESUME':siteSetting.api.v2 + "concierge/resume",
    'CONCIERGE_CONVERSATIONS':siteSetting.api.v2 + "concierge/conversations",   // GET ?before&limit&filter&channel&q&clientUserId; /:id; /:id/reply; /:id/takeover

    'ADD_TERMINAL':siteSetting.api.v2 + "payment/addStripeTerminal",
    'GET_TERMINAL':siteSetting.api.v2 + "payment/addStripeTerminal",

    'REQUEST_CARD_READER':siteSetting.api.v2 + "payment/requestCardReader",
    'FETCH_CONNECTION_TOKEN':siteSetting.api.v2 + "payment/fetchConnectionToken",
    'NO_SHOW_BOOKING': siteSetting.api.v2 + "payment/noShow",
    'REMOVE_BOOKING': siteSetting.api.v2 + "booking/remove",


    

    'CARD_READER_LIST':siteSetting.api.v2 + "payment/cardReaderList",
    'CARD_READER_DELETE':siteSetting.api.v2 + "payment/cardReaderDelete",

    'CARD_READER_PAYMENTINTENTS':siteSetting.api.v2 + "payment/paymentIntents",
    'PAYMENTINTENT_CAPTURE':siteSetting.api.v2 + "payment/paymentIntentsCapture",
    'SUBSCRIPTION_GET':siteSetting.api.v2 + "payment/subscriptionGet",

    'ADD_STAFF_V2':siteSetting.api.v2 + "user/addStaff",
    'REMOVE_STAFF_V2':siteSetting.api.v2 + "user/removeStaff",
    'EDIT_STAFF_V2':siteSetting.api.v2 + "user/editStaff",
    'UPDATE_STAFF_PAY':siteSetting.api.v2 + "user/updateStaffPay",
    'STAFF_LIST_V2':siteSetting.api.v2 + "hairdresser/hairdresser-staff",
    'DIARY_DATA':siteSetting.api.v2 + "diary",
    'DIARY_STAFF_ORDER':siteSetting.api.v2 + "diary/staff-order",
    'GET_HAIRDRESSER_POLICIES_V2':siteSetting.api.v2 + "hairdresser/getHairdresserPolicies",
    

    'UPDATE_TRANSACTION_FEE':siteSetting.api.v2 + "payment/updateTransactionFee",
    'TRANSACTION_FEE':siteSetting.api.v2 + "payment/transactionFee",
    'CREATE_LOGIN_LINK':siteSetting.api.v2 + "payment/createLoginLink",
    'LAST_BOOKED_CLIENTS':siteSetting.api.v2 + "hairdresser/last-booked-clients",
    'HAIRDRESSER_UPDATE_INTERVAL':siteSetting.api.v2 + "hairdresser/updateBookingInterval",
    'HAIRDRESSER_CLIENTS_PAGINATED':siteSetting.api.v2 + "hairdresser/clients",
    'HAIRDRESSER_CLIENT_SHARING':siteSetting.api.v2 + "hairdresser/client-sharing-v2",
    'HAIRDRESSER_CLIENTS_OWNERSHIP':siteSetting.api.v2 + "hairdresser/clients/ownership",
    'HAIRDRESSER_CLIENTS_EXPORT':siteSetting.api.v2 + "hairdresser/clients/export",
    'HAIRDRESSER_SHARING_SETTINGS':siteSetting.api.v2 + "hairdresser/sharing-settings",
    'HAIRDRESSER_SALON_CLIENT_ACCESS':siteSetting.api.v2 + "hairdresser/salon-client-access",
    'HAIRDRESSER_SALON_CLIENT_ACCESS_BULK':siteSetting.api.v2 + "hairdresser/salon-client-access-bulk",

    'RETRIEVE_PAYOUTS':siteSetting.api.v2 + "payment/retrieve-payouts",
    'CHECKOUT_NEW_BOOKING': siteSetting.api.v2 + "booking/new-checkout",
    'CREATE_BOOKING_V2': siteSetting.api.v2 + "booking/create",
    // Repeat bookings (2026-10-06): check / create / get / stop
    'BOOKING_SERIES': siteSetting.api.v2 + "booking-series",
    'UPDATE_BOOKING_NOTES': siteSetting.api.v2 + "booking/",
    'GET_BOOKING_V2': siteSetting.api.v2 + "booking/",

    'CHECKOUT_EDIT_BOOKING': siteSetting.api.v2 + "booking/checkout-edit",

    'CANCEL_TERMINAL_TRANSACTION':siteSetting.api.v2 + "payment/readerCancelAction",
    'CHECK_CARD_ADDED':siteSetting.api.v2 + "payment/checkCardAdded",
    'PAYMENT_METHOD_ADD':siteSetting.api.v2 + "payment/paymentMethodAdd",
    'CARD_REMOVE':siteSetting.api.v2 + "payment/cardRemove",
    'CARD_MAKE_PRIMERY':siteSetting.api.v2 + "payment/cardMakePrimery",
    'SETUP_PAYMENT_INTENT':siteSetting.api.v2 + "payment/customerIntentSetup",
    'CREATE_PAYMENT_LINK':siteSetting.api.v2 + "payment/createPaymentLink",
    'CREATE_GIFT_CARD_PAYMENT_LINK':siteSetting.api.v2 + "payment/createGiftCardPaymentLink",
    'GIFT_CARD_ORDER_STATUS':siteSetting.api.v2 + "payment/giftCardOrderStatus",
    'CHECK_PAYMENT_LINK_STATUS':siteSetting.api.v2 + "payment/checkPaymentLinkStatus",
    'CREATE_KLARNA_PAYMENT_LINK':siteSetting.api.v2 + "payment/createKlarnaPaymentLink",
    'CREATE_CLEARPAY_PAYMENT_LINK':siteSetting.api.v2 + "payment/createClearpayPaymentLink",
    'SEND_PAYMENT_LINK_EMAIL':siteSetting.api.v2 + "payment/sendPaymentLinkEmail",
    'PAYMENT_SUCCESS_BOOKING':siteSetting.api.v2 + "payment/paymentSuccessBooking",

    'CHECKOUT_EDIT_SERVICE_PRODUCT': siteSetting.api.v2 + "booking/edit-checkout-payment",

    'CREATE_MARKETING_SETTING':siteSetting.api.v2 + "setting/create",
    'UPDATE_SETTING':siteSetting.api.v2 + "setting/update",
    'GET_MARKETING_SETTING':siteSetting.api.v2 + "setting/get",
    'GET_MARKETING_SALON_SETTING':siteSetting.api.v2 + "setting/get-marketing-setting",
    'SMS_WALLET_TOPUP':siteSetting.api.v2 + "setting/sms-wallet/topup",

    // Client-side marketing preferences (authed client)
    'MY_MARKETING_PREFERENCES':siteSetting.api.v2 + "marketing/my-preferences",
    'SMS_WALLET_CONFIRM':siteSetting.api.v2 + "setting/sms-wallet/confirm",
    'SMS_WALLET_AUTORECHARGE':siteSetting.api.v2 + "setting/sms-wallet/auto-recharge",
    'SMS_WALLET_PURCHASES':siteSetting.api.v2 + "setting/sms-wallet/purchases",
    'SMS_WALLET_CHECKOUT':siteSetting.api.v2 + "setting/sms-wallet/checkout",
    // Multi-location: shared balance, free allowance per location, separate switch
    'SMS_WALLET_LOCATIONS':siteSetting.api.v2 + "setting/sms-wallet/locations",
    'SMS_WALLET_SEPARATE':siteSetting.api.v2 + "setting/sms-wallet/separate",
    'CREATE_REMINDER':siteSetting.api.v2 + "setting/create-reminder",
    'REMOVE_REMINDER':siteSetting.api.v2 + "setting/remove-reminder",
    'UPLOAD_REMINDER_IMAGE':siteSetting.api.v2 + "setting/upload-reminder-image",
    'UPLOAD_EMAIL_BODY_IMAGE':siteSetting.api.v2 + "setting/upload-email-body-image",
    'DELETE_EMAIL_BODY_IMAGE':siteSetting.api.v2 + "setting/delete-email-body-image",

    // Campaign endpoints
    'CREATE_CAMPAIGN':siteSetting.api.v2 + "campaign/create",
    'UPDATE_CAMPAIGN':siteSetting.api.v2 + "campaign/update",
    'SEND_CAMPAIGN':siteSetting.api.v2 + "campaign/send",
    'GET_CAMPAIGNS':siteSetting.api.v2 + "campaign/list",
    'GET_CAMPAIGN_DETAILS':siteSetting.api.v2 + "campaign/details",
    'GET_CAMPAIGN_RECIPIENTS':siteSetting.api.v2 + "campaign/recipients",
    'DELETE_CAMPAIGN':siteSetting.api.v2 + "campaign/delete",
    'ESTIMATE_CAMPAIGN_COST':siteSetting.api.v2 + "campaign/estimate-cost",
    'GET_AUDIENCE_SEGMENTS':siteSetting.api.v2 + "campaign/audience-segments",

    // Analytics endpoints
    'GET_ANALYTICS_OVERVIEW':siteSetting.api.v2 + "analytics/overview",
    // Public: a visit to a tracked booking link (?src=)
    'ANALYTICS_LINK_VISIT':siteSetting.api.v2 + "analytics/link-visit",
    'GET_AUTOMATION_STATS':siteSetting.api.v2 + "analytics/automations",
    'GET_CLIENT_COMMUNICATIONS':siteSetting.api.v2 + "analytics/client-communications",
    'GET_EMAIL_TEMPLATE_PREVIEW':siteSetting.api.v2 + "setting/email-template-preview",
    'GET_MARKETING_INSIGHTS':siteSetting.api.v2 + "analytics/insights",
    'EXPORT_ANALYTICS':siteSetting.api.v2 + "analytics/export",
    'GET_SALON_REVIEWS':siteSetting.api.v2 + "review/salon",

    'UPDATE_CANCELLATION_POLICY':siteSetting.api.v2 + "setting/updateCancellationPolicy",
    'UPDATE_NO_SHOW_PROTECTION_FEE':siteSetting.api.v2 + "setting/updateNoShowProtectionFee",
    'GET_CANCELLATION_POLICY':siteSetting.api.v2 + "setting/getCancellationPolicy",

    'BOOKING_COMPLETE': siteSetting.api.v2 + "booking/complete",
    'CANCEL_BOOKING': siteSetting.api.v2 + "booking/cancelBooking",
    'SALON_CANCEL_BOOKING': siteSetting.api.v2 + "booking/salon-cancel",
    'PREVIEW_CANCELLATION_FEE': siteSetting.api.v2 + "booking/previewCancellationFee",
    
    'EDIT_DAIRY_BOOKING': siteSetting.api.v2 + "booking/edit-dairy-booking",
    'GET_MARKETING_INVOICE_LIST':siteSetting.api.v2 + "marketingInvoice/invoiceList",
    'UPDATE_MARKETING_SETTING':siteSetting.api.v2 + "setting/update-marketing-setting",

   
   'CREATE_CATEGORY':siteSetting.api.v2 + "category/create",
   'EDIT_CATEGORY':siteSetting.api.v2 + "category/edit",
   'DELETE_CATEGORY':siteSetting.api.v2 + "category/delete",
   'LIST_CAETGORY': siteSetting.api.v2 + "category/list",

   'CREATE_SERVICES':siteSetting.api.v2 + "service/create",
   'LIST_SERVICES': siteSetting.api.v2 + "service/list",
   'DELETE_SERVICES':siteSetting.api.v2 + "service/delete",
   'VIEW_SERVICES': siteSetting.api.v2 + "service/view",
   'EDIT_SERVICES':siteSetting.api.v2 + "service/edit",
   'LIST_HAIRDRESSER' : siteSetting.api.v2 + "service/hairdresserList",
   'CATEGORY_ORDERCHANGE':siteSetting.api.v2 + "category/orderChange" ,
   'SERVICE_ORDERCHANGE':siteSetting.api.v2 + "service/orderChange" ,
   'SERVICE_SHARESETTING':siteSetting.api.v2 + "service/serviceShareSetting" ,
   'SERVICE_STATUSCHANGE':siteSetting.api.v2 + "service/statusChange" ,
   'UPLOAD_SERVICE_IMAGE':siteSetting.api.v2 + "service/uploadServiceImage" ,
   'UPLOAD_STAFF_SERVICE_IMAGE':siteSetting.api.v2 + "service/uploadStaffServiceImage" ,
   'DELETE_SERVICE_IMAGE':siteSetting.api.v2 + "service/deleteServiceImage" ,
   'TOGGLE_FEATURED':siteSetting.api.v2 + "service/toggleFeatured" ,
   'GET_FEATURED_SERVICES':siteSetting.api.v2 + "service/featuredList" ,
   'UPDATE_FEATURED_ORDER':siteSetting.api.v2 + "service/featuredOrderChange" ,
   'SERVICE_ONLINE_STAFF_MAP':siteSetting.api.v2 + "service/onlineStaffMap" ,
    'CLIENT_SHARE':siteSetting.api.v2 + "hairdresser/client-share",
    'DATE_RANGE_AVAILABILITY': siteSetting.api.v2 + "salon/:salonId/hairdresser/:hairdresserId/date-range-availability",
    'AVAILABLE_SLOTS': siteSetting.api.v2 + "salon/:salonId/hairdresser/:hairdresserId/available-slots",
    'BOOKING_SLOTS_V2': siteSetting.api.v2 + "salon/:salonId/hairdresser/:hairdresserId/booking-slots",
    
    // Cashup API endpoints
    'CASHUP_HISTORY': siteSetting.api.v2 + "cashup/history",
    'CASHUP_GET_BY_ID': siteSetting.api.v2 + "cashup",
    'CASHUP_CREATE': siteSetting.api.v2 + "cashup",
    'CASHUP_UPDATE': siteSetting.api.v2 + "cashup",
    'CASHUP_COMPLETE': siteSetting.api.v2 + "cashup",
    'CASHUP_STATS': siteSetting.api.v2 + "cashup/stats",

    // Stock Take API endpoints
    'CREATE_STOCKTAKE': siteSetting.api.v2 + "stocktake/create",
    'GET_STOCKTAKE': siteSetting.api.v2 + "stocktake",
    'UPDATE_STOCKTAKE': siteSetting.api.v2 + "stocktake/update",
    'COMPLETE_STOCKTAKE': siteSetting.api.v2 + "stocktake/complete",
    'GET_STOCKTAKE_HISTORY': siteSetting.api.v2 + "stocktake/history",
    'DELETE_STOCKTAKE': siteSetting.api.v2 + "stocktake",
    'SEARCH_STOCKTAKE_ITEMS': siteSetting.api.v2 + "stocktake/search-items",

    // Voucher API endpoints
    'VOUCHER_SETTINGS': siteSetting.api.v2 + "voucher/settings",
    'VOUCHER_SETTINGS_UPDATE': siteSetting.api.v2 + "voucher/settings/update",
    'VOUCHER_CREATE': siteSetting.api.v2 + "voucher/catalog/create",
    'VOUCHER_LIST': siteSetting.api.v2 + "voucher/catalog/list",
    'VOUCHER_SALES': siteSetting.api.v2 + "voucher/instance/list",
    'VOUCHER_SALES_DASHBOARD': siteSetting.api.v2 + "voucher/instance/sales-dashboard",
    'VOUCHER_VIEW': siteSetting.api.v2 + "voucher/instance/view",
    'VOUCHER_UPDATE': siteSetting.api.v2 + "voucher/catalog/update",
    'VOUCHER_DELETE': siteSetting.api.v2 + "voucher/catalog/delete",
    'VOUCHER_DASHBOARD': siteSetting.api.v2 + "voucher/dashboard",
    'VOUCHER_BULK_UPDATE': siteSetting.api.v2 + "voucher/bulk-update",
    'VOUCHER_SELL': siteSetting.api.v2 + "voucher/sell",
    'VOUCHER_UPDATE_BALANCE': siteSetting.api.v2 + "voucher/update-balance",
    'VOUCHER_ISSUE': siteSetting.api.v2 + "voucher/issue",
    'VOUCHER_REDEEM': siteSetting.api.v2 + "voucher/redeem",
    'VOUCHER_VOID': siteSetting.api.v2 + "voucher/void",
    'VOUCHER_RESEND_EMAIL': siteSetting.api.v2 + "voucher/resend-email",
    'VOUCHER_UPDATE_REDEMPTION': siteSetting.api.v2 + "voucher/update-redemption",
    // Voucher V2 (gift-card overhaul) design library
    'VOUCHER_DESIGN_LIST': siteSetting.api.v2 + "voucher/design/list",
    'VOUCHER_DESIGN_TOGGLE': siteSetting.api.v2 + "voucher/design/toggle",
    'VOUCHER_DESIGN_SAVE_CUSTOM': siteSetting.api.v2 + "voucher/design/save-custom",
    'VOUCHER_DESIGN_STATS': siteSetting.api.v2 + "voucher/design/stats",
    'VOUCHER_NOTIFY_EXPIRING': siteSetting.api.v2 + "voucher/notify-expiring",
    'VOUCHER_ATTACH_CLIENT': siteSetting.api.v2 + "voucher/attach-client",
    // Customer wallet
    'VOUCHER_MY_LIST': siteSetting.api.v2 + "voucher/my-list",
    'VOUCHER_CLAIM': siteSetting.api.v2 + "voucher/claim",
    'VOUCHER_SET_DESIGN': siteSetting.api.v2 + "voucher/set-design",
    // Reception Mode API endpoints
    'RECEPTION_MODE_SETTINGS': siteSetting.api.v2 + "reception-mode/settings",
    'RECEPTION_MODE_SETUP_PIN': siteSetting.api.v2 + "reception-mode/setup-pin",
    'RECEPTION_MODE_VERIFY_PIN': siteSetting.api.v2 + "reception-mode/verify-pin",
    'RECEPTION_MODE_RESET_PIN': siteSetting.api.v2 + "reception-mode/reset-pin",
    'RECEPTION_MODE_RESET_LOCKOUT': siteSetting.api.v2 + "reception-mode/reset-lockout",
    'RECEPTION_MODE_GENERATE_RESET_CODE': siteSetting.api.v2 + "reception-mode/generate-reset-code",
    'RECEPTION_MODE_VERIFY_RESET_CODE': siteSetting.api.v2 + "reception-mode/verify-reset-code",
    'RECEPTION_MODE_UNLOCK': siteSetting.api.v2 + "reception-mode/unlock",
    'RECEPTION_MODE_LOCK': siteSetting.api.v2 + "reception-mode/lock",
    'RECEPTION_MODE_CHANGE_PIN': siteSetting.api.v2 + "reception-mode/change-pin",
    'RECEPTION_MODE_FRONT_DESK': siteSetting.api.v2 + "reception-mode/front-desk",
    
    // Payment Methods API endpoints
    'PAYMENT_METHODS_GET': siteSetting.api.v2 + "hairdresser/payment-methods",
    'PAYMENT_METHODS_UPDATE': siteSetting.api.v2 + "hairdresser/payment-methods",
    
    // Receipt API endpoints
    'SEND_RECEIPT_EMAIL': siteSetting.api.v2 + "receipt/send-email",

    // Booking confirmation
    'RESEND_BOOKING_CONFIRMATION': siteSetting.api.v2 + "booking/resend-confirmation",
    
    // Marketplace API endpoints
    'MARKETPLACE_HOME': siteSetting.api.v2 + "marketplace/home",
    'MARKETPLACE_RECOMMENDED': siteSetting.api.v2 + "marketplace/recommended",
    'MARKETPLACE_NEW': siteSetting.api.v2 + "marketplace/new",
    'MARKETPLACE_SEARCH': siteSetting.api.v2 + "marketplace/search",
    'MARKETPLACE_CATEGORIES': siteSetting.api.v2 + "marketplace/categories",

    // Browse/landing page API endpoints (public, no auth)
    'BROWSE_LOCATIONS': siteSetting.api.v2 + "public/browse/locations",
    'BROWSE_CATEGORY': siteSetting.api.v2 + "public/browse",

    // Salon Summary API endpoint (for public salon detail page)
    'SALON_SUMMARY': siteSetting.api.v2 + "salon",
    
    // Salon Opening Hours API endpoints
    'SALON_OPENING_HOURS': siteSetting.api.v2 + "salon",
    
    // Staff Summary API endpoint (for public staff detail page)
    'STAFF_SUMMARY': siteSetting.api.v2 + "hairdresser",
    
    // Hairdresser Profile API endpoints (for settings/profile page)
    'HAIRDRESSER_PROFILE_GET': siteSetting.api.v2 + "hairdresser/profile",
    'HAIRDRESSER_PROFILE_UPDATE': siteSetting.api.v2 + "hairdresser/profile",
    'SERVICE_HAIRDRESSER_LIST_V2': siteSetting.api.v2 + "hairdresser/service-hairdresser-list",
    'HAIRDRESSER_PORTFOLIO_UPLOAD': siteSetting.api.v2 + "hairdresser/portfolio",
    'HAIRDRESSER_PORTFOLIO_DELETE': siteSetting.api.v2 + "hairdresser/portfolio",
    
    // Review API endpoints
    'REVIEW_SUBMIT': siteSetting.api.v2 + "review/submit",
    'REVIEW_SUBMIT_BOTH': siteSetting.api.v2 + "review/submit-both",
    'REVIEW_BOOKING_STATUS': siteSetting.api.v2 + "review/booking-status",
    'REVIEW_HAIRDRESSER': siteSetting.api.v2 + "review/hairdresser",
    'REVIEW_SALON': siteSetting.api.v2 + "review/salon",
    'REVIEW_MY_REVIEWS': siteSetting.api.v2 + "review/my-reviews",
    
    // Client Booking API endpoints (v2)
    'CLIENT_UPCOMING_BOOKINGS': siteSetting.api.v2 + "booking/client/upcoming",
    'CLIENT_PAST_BOOKINGS': siteSetting.api.v2 + "booking/client/past",
    // Get single booking by ID (v2) - hairdresser/staff access
    'GET_BOOKING_BY_ID': siteSetting.api.v2 + "booking/",
    // Get single booking by ID for the client who made it
    'GET_CLIENT_BOOKING_BY_ID': siteSetting.api.v2 + "booking/client/",
    // Create online booking (v2) - adds client to hairdresser's client list
    'CREATE_ONLINE_BOOKING': siteSetting.api.v2 + "booking/online-booking",
    // Guest checkout OTP (no auth). send-otp emails a code (SMS on request);
    // for an email that belongs to a claimed account it returns
    // outcome:'account_exists' and sends the code to the REGISTERED contact.
    // verify-otp returns 'verified' (guest may now book) or 'logged_in'
    // (claimed account — real session tokens; continue as a logged-in client).
    'GUEST_SEND_OTP': siteSetting.api.v2 + "booking/guest/send-otp",
    'GUEST_VERIFY_OTP': siteSetting.api.v2 + "booking/guest/verify-otp",
    // Guest booking (v2) - no auth; pay-at-salon only; creates/reuses an
    // unclaimed client record. Requires a verified OTP for the guest email.
    // See GUEST-BOOKING-PLAN.md §4.2 + docs/guest-booking-be.md.
    'CREATE_GUEST_BOOKING': siteSetting.api.v2 + "booking/guest",
    // Resolves who would OWN a prospective booking's client under Rule 1
    // (marketing attribution) so the consent checkbox can name the right
    // sender before submit. See GUEST-BOOKING-PLAN.md §5A.
    'BOOKING_CONSENT_CONTEXT': siteSetting.api.v2 + "booking/consent-context",
    // Guest → account: emails the existing claim link for the guest's
    // unclaimed record (same path as salon-created accounts). §4.4.
    'GUEST_SEND_CLAIM_LINK': siteSetting.api.v2 + "booking/guest/send-claim-link",
    // beu-be docs/client-flows.md §7.4: email verification for the silent
    // salon-record sync (signup code step + the plain /find-my-bookings
    // page). Dark until the BE flag CLIENT_CLAIM_ENABLED is on.
    'CLIENT_CLAIM_STATUS': siteSetting.api.v2 + "client-claim/status",
    'CLIENT_CLAIM_SEND_CODE': siteSetting.api.v2 + "client-claim/send-code",
    'CLIENT_CLAIM_VERIFY': siteSetting.api.v2 + "client-claim/verify",
    'CLIENT_CLAIM_COMPLETE': siteSetting.api.v2 + "client-claim/complete",
    
    // Client Add API endpoint (v2)
    'CLIENT_ADD': siteSetting.api.v2 + "hairdresser/clients/add",
    // Soft-delete a client from the salon's book. v2 because the v1 route only
    // wrote the legacy removeClient array, which migrated salons never read.
    'HAIRDRESSER_CLIENT_REMOVE': siteSetting.api.v2 + "hairdresser/clients/remove",

    // Finance API endpoints
    'FINANCE_OVERVIEW_REVENUE': siteSetting.api.v2 + "finance/overview/revenue",
    'FINANCE_OVERVIEW_COMMISSION': siteSetting.api.v2 + "finance/overview/commission",
    'FINANCE_OVERVIEW_COMMISSION_DETAIL': siteSetting.api.v2 + "finance/overview/commission/detail",
    'FINANCE_OVERVIEW_COMMISSION_COLLECT': siteSetting.api.v2 + "finance/overview/commission/collect",
    'FINANCE_OVERVIEW_COMMISSION_PAYMENT_LINK': siteSetting.api.v2 + "finance/overview/commission/payment-link",
    'FINANCE_OVERVIEW_COMMISSION_PAYMENT_STATUS': siteSetting.api.v2 + "finance/overview/commission/payment-status",
    'FINANCE_OVERVIEW_COMMISSION_PAYMENTS': siteSetting.api.v2 + "finance/overview/commission/payments",
    'FINANCE_OVERVIEW_TIPS': siteSetting.api.v2 + "finance/overview/tips",
    'FINANCE_OVERVIEW_METRICS': siteSetting.api.v2 + "finance/overview/metrics",
    'FINANCE_OVERVIEW_PAYMENT_BREAKDOWN': siteSetting.api.v2 + "finance/overview/payment-breakdown",
    'FINANCE_OVERVIEW_LIABILITIES': siteSetting.api.v2 + "finance/overview/liabilities",
    'FINANCE_OVERVIEW_LOST_REVENUE': siteSetting.api.v2 + "finance/overview/lost-revenue",
    'FINANCE_OVERVIEW_APPOINTMENTS': siteSetting.api.v2 + "finance/overview/appointments",
    'FINANCE_OVERVIEW_REBOOKING_RATE': siteSetting.api.v2 + "finance/overview/rebooking-rate",
    'FINANCE_OVERVIEW_VOUCHERS': siteSetting.api.v2 + "finance/overview/vouchers",
    'FINANCE_OVERVIEW_NEW_CLIENTS': siteSetting.api.v2 + "finance/overview/new-clients",
    'FINANCE_OVERVIEW_TOP_CLIENTS': siteSetting.api.v2 + "finance/overview/top-clients",
    'FINANCE_OVERVIEW_PERFORMANCE': siteSetting.api.v2 + "finance/overview/performance",
    'FINANCE_OVERVIEW_ALL': siteSetting.api.v2 + "finance/overview/all",
    'FINANCE_OVERVIEW_BY_SITE': siteSetting.api.v2 + "finance/overview/by-site",   // Locations filter: revenue per location
    'FINANCE_TRANSACTIONS': siteSetting.api.v2 + "finance/transactions",
    'FINANCE_TRANSACTIONS_EXPORT': siteSetting.api.v2 + "finance/transactions/export",
    'FINANCE_TRANSACTIONS_EXPORT_COUNT': siteSetting.api.v2 + "finance/transactions/export/count",
    'FINANCE_TRANSACTION_DETAIL': siteSetting.api.v2 + "finance/transactions",
    'FINANCE_REPORTS_TYPES': siteSetting.api.v2 + "finance/reports/types",
    'FINANCE_REPORTS_GENERATE': siteSetting.api.v2 + "finance/reports/generate",
    'FINANCE_REPORTS_GET': siteSetting.api.v2 + "finance/reports",
    'FINANCE_REPORTS_DOWNLOAD': siteSetting.api.v2 + "finance/reports",

    // Form API endpoints
    'FORM_CREATE': siteSetting.api.v2 + "form/create",
    'FORM_EDIT': siteSetting.api.v2 + "form/edit",
    'FORM_DELETE': siteSetting.api.v2 + "form/delete",
    'FORM_VIEW': siteSetting.api.v2 + "form/view",
    'FORM_LIST': siteSetting.api.v2 + "form/list",
    'FORM_SHARE_SETTING': siteSetting.api.v2 + "form/shareSetting",
    'FORM_SEND': siteSetting.api.v2 + "form/send",
    'FORM_SUBMIT': siteSetting.api.v2 + "form/submit",
    'FORM_SUBMISSION_LIST': siteSetting.api.v2 + "form/submission/list",
    'FORM_SUBMISSION_BOOKING': siteSetting.api.v2 + "form/submission/booking",
    'FORM_SUBMISSION_REMOVE': siteSetting.api.v2 + "form/submission/remove",
    'FORM_SUBMISSION_VIEW': siteSetting.api.v2 + "form/submission/view",
    'FORM_ATTACH_BOOKING': siteSetting.api.v2 + "form/attach-to-booking",
    'FORM_BOOKING_FORMS': siteSetting.api.v2 + "form/booking-forms",
    'FORM_UPLOAD_HERO_IMAGE': siteSetting.api.v2 + "form/uploadHeroImage",
    'FORM_DELETE_HERO_IMAGE': siteSetting.api.v2 + "form/deleteHeroImage",
    'FORM_SET_HERO_IMAGE': siteSetting.api.v2 + "form/setHeroImage",
    'FORM_PUBLIC_VIEW': siteSetting.api.v2 + "form/public/view",
    'FORM_PUBLIC_SUBMIT': siteSetting.api.v2 + "form/public/submit",

    // Diary sharing (per-staff visibility on the shared diary)
    'DIARY_SHARING_SETTINGS': siteSetting.api.v2 + "diary-sharing/settings",
    'DIARY_SHARING_STAFF': siteSetting.api.v2 + "diary-sharing/staff/",   // append staffHairdresserId
    'DIARY_SHARE': siteSetting.api.v2 + "hairdresser/diary-share",   // salon-level switch, owner only
    'DIARY_SHARING_ME': siteSetting.api.v2 + "diary-sharing/me",

    // Self-employed stylists' choices: Team › Their choices (owner / team) and
    // Settings › Your choices (the SE's own). Reads only.
    'TEAM_SE_CHOICES': siteSetting.api.v2 + "team/se-choices",
    'TEAM_SE_CHOICES_ME': siteSetting.api.v2 + "team/se-choices/me",

    // Notifications V2 (server-backed bell + preferences + push-ready)
    'NOTIFICATION_V2_LIST': siteSetting.api.v2 + "notification-v2",
    'NOTIFICATION_V2_UNREAD_COUNT': siteSetting.api.v2 + "notification-v2/unread-count",
    // One routine poll for badges + "has X changed?" (src/_utils/syncSummary.js)
    'SYNC_SUMMARY': siteSetting.api.v2 + "sync/summary",
    'NOTIFICATION_V2_READ': siteSetting.api.v2 + "notification-v2/",       // append :id + /read
    'NOTIFICATION_V2_MARK_ALL_READ': siteSetting.api.v2 + "notification-v2/mark-all-read",
    'NOTIFICATION_V2_ARCHIVE': siteSetting.api.v2 + "notification-v2/",    // append :id + /archive
    'NOTIFICATION_V2_DELETE': siteSetting.api.v2 + "notification-v2/",     // append :id
    'NOTIFICATION_V2_PREFERENCES': siteSetting.api.v2 + "notification-v2/preferences",

    // Client photos — per-client photo timeline + consent + tag aggregations
    'CLIENT_PHOTO_LIST': siteSetting.api.v2 + "client-photo/client/",          // append :clientId + ?cursorAt&cursorId&limit
    'CLIENT_PHOTO_UPLOAD': siteSetting.api.v2 + "client-photo/client/",        // append :clientId (multipart, field: photo)
    'CLIENT_PHOTO_ITEM': siteSetting.api.v2 + "client-photo/",                 // append :photoId (PATCH/DELETE)
    'CLIENT_PHOTO_CONSENT': siteSetting.api.v2 + "client-photo/client/",       // append :clientId + /consent (POST/DELETE)
    'CLIENT_PHOTO_SALON_TAGS': siteSetting.api.v2 + "client-photo/salon/tags",
    'CLIENT_PHOTO_TAGS_FOR_SERVICE': siteSetting.api.v2 + "client-photo/salon/tags-for-service",
    'CLIENT_PHOTO_SALON': siteSetting.api.v2 + "client-photo/salon",                 // ?tag=before|after&consent=social|shareable&cursor=<iso>|<id>&limit
    'CLIENT_PHOTO_SHARE_CONSENT': siteSetting.api.v2 + "client-photo/",        // append :photoId + /share-consent (PUT { value })
    'CLIENT_PHOTO_SOCIAL_CONSENT': siteSetting.api.v2 + "client-photo/client/", // append :clientId + /social-consent (POST/DELETE)
    // Social posts (Marketing > Social; docs/SOCIAL_BACKEND.md §1)
    'SOCIAL_POSTS': siteSetting.api.v2 + "social/posts",                        // GET ?from&to&status&source, POST; /:id PUT/DELETE; /:id/restore POST

    // Marketing suite backend (replaces the FE-first localStorage stores)
    'MARKETING_TEMPLATES': siteSetting.api.v2 + "marketing/templates",
    'MARKETING_TEMPLATES_DELETE': siteSetting.api.v2 + "marketing/templates/delete",
    'MARKETING_BUSINESS_DETAILS': siteSetting.api.v2 + "marketing/business-details",
    'MARKETING_UPLOAD_IMAGE': siteSetting.api.v2 + "marketing/upload-image",
    'MARKETING_IMAGES': siteSetting.api.v2 + "marketing/images",             // GET list, POST add (own bucket), DELETE /:id
    'MARKETING_PLAN_MEMORY': siteSetting.api.v2 + "marketing/plans/memory",     // GET / PUT (merge per key)
    'MARKETING_CAMPAIGN_GROUP': siteSetting.api.v2 + "marketing/campaign-group", // Studio campaigns: GET list, /:id GET/PUT/DELETE, /:id/cancel, /:id/copy
    'LOYALTY_SCHEME': siteSetting.api.v2 + "loyalty/scheme",
    'LOYALTY_WALLET': siteSetting.api.v2 + "loyalty/wallet",
    'LOYALTY_CLIENT_CARDS': siteSetting.api.v2 + "loyalty/client-cards",
    'LOYALTY_CLIENT_HISTORY': siteSetting.api.v2 + "loyalty/client-history",
    'LOYALTY_SCHEME_REMOVE': siteSetting.api.v2 + "loyalty/scheme/remove",
    'LOYALTY_SCHEME_INFLIGHT': siteSetting.api.v2 + "loyalty/scheme/inflight",
    'LOYALTY_STATS': siteSetting.api.v2 + "loyalty/stats",
    'LOYALTY_ELECTION_OFFER': siteSetting.api.v2 + "loyalty/election/offer",
    'LOYALTY_ELECTION_JOIN': siteSetting.api.v2 + "loyalty/election/join",
    'LOYALTY_ELECTION_LIST': siteSetting.api.v2 + "loyalty/election/list",
    // Discount codes (docs/DISCOUNT_CODES_BACKEND.md). On the server since
    // 2026-10-13 (beu-node-v2 lib/module/v2/discount); staging falls back to
    // the device stand-in only when the server answers 404.
    'DISCOUNT_LIST': siteSetting.api.v2 + "discount/list",
    'DISCOUNT_SAVE': siteSetting.api.v2 + "discount/save",
    'DISCOUNT_STATUS': siteSetting.api.v2 + "discount/status",
    'DISCOUNT_VALIDATE': siteSetting.api.v2 + "discount/validate",
    'DISCOUNT_REDEEM': siteSetting.api.v2 + "discount/redeem",
    'DISCOUNT_RELEASE': siteSetting.api.v2 + "discount/release",
    'DISCOUNT_CHOICE': siteSetting.api.v2 + "discount/choice",
    'DISCOUNT_CHOICES': siteSetting.api.v2 + "discount/choices",
    // Selling below the menu: 'log' (default) | 'refuse' (beu-node-v2 discount/manualDiscount.js)
    'DISCOUNT_MANUAL_RULE': siteSetting.api.v2 + "discount/manual-rule",
    // Multi-location (beu-node-v2 docs/multi-location*.md) — /api/v2/sites/*
    'SITES': siteSetting.api.v2 + "sites/",
    // A client's Messages: GET /:clientId · POST /:clientId (send) · POST /:clientId/read · GET /unread
    'CLIENT_MESSAGES': siteSetting.api.v2 + "client-messages",
    // Settings › Business numbers: GET / · GET /options · POST / · PATCH /:id · POST /:id/move · DELETE /:id
    'BUSINESS_NUMBERS': siteSetting.api.v2 + "business-numbers",
    // Pricing (Oct 2026): GET /billing/usage · POST /billing/bailey-upgrade ·
    // POST /billing/receptionist-pack · PUT /billing/receptionist-auto-packs
    'BILLING': siteSetting.api.v2 + "billing",
    // Roles & permissions (beu-node-v2 docs/permissions.md §4).
    'PERMISSIONS': siteSetting.api.v2 + "permissions/",
    // Refunds on a completed sale (beu-node-v2 docs/refunds.md): /api/v2/refunds
    'REFUNDS': siteSetting.api.v2 + "refunds",
    'TAX_LIST': siteSetting.api.v2 + "tax/list",
    'TAX_SAVE': siteSetting.api.v2 + "tax/save",
    'TAX_DELETE': siteSetting.api.v2 + "tax/delete",
    'TAX_MODE': siteSetting.api.v2 + "tax/mode",
    'TAX_ITEM_OVERRIDE': siteSetting.api.v2 + "tax/item-override",
    'TAX_SETTINGS': siteSetting.api.v2 + "tax/settings",
    'TAX_FOR_SELLER': siteSetting.api.v2 + "tax/for-seller",
    'TAX_CATEGORIES': siteSetting.api.v2 + "tax/categories",
    'TAX_CATEGORY_OVERRIDE': siteSetting.api.v2 + "tax/category-override",
    'TAX_PRESETS': siteSetting.api.v2 + "tax/presets",
    'JOURNEY_LIST': siteSetting.api.v2 + "journey/list",
    'JOURNEY_SAVE': siteSetting.api.v2 + "journey/save",
    'JOURNEY_STATUS': siteSetting.api.v2 + "journey/status",
    'JOURNEY_DELETE': siteSetting.api.v2 + "journey/delete",
    'JOURNEY_RUNS_LIST': siteSetting.api.v2 + "journey/runs/list",
    'JOURNEY_RUNS_CANCEL': siteSetting.api.v2 + "journey/runs/cancel",
    'JOURNEY_RUNS_BY_CLIENT': siteSetting.api.v2 + "journey/runs/by-client",

    // ---- client marketing-consent (panel: Message > Consent history / Messages) ----
    'CLIENT_CONSENT_HISTORY': siteSetting.api.v2 + "client/consent-history",
    'CLIENT_MARKETING_MESSAGES': siteSetting.api.v2 + "client/marketing-messages",

    // ---- client panel: paginated history tabs (Bookings / Sales) ----
    'CLIENT_BOOKINGS': siteSetting.api.v2 + "client/bookings",
    'CLIENT_SALES': siteSetting.api.v2 + "client/sales",

    // ---- AI onboarding / import (ONBOARDING-IMPORT-PLAN.md §7) ----
    'IMPORT_FILES': siteSetting.api.v2 + "import/files",            // POST multipart
    'IMPORT_JOBS': siteSetting.api.v2 + "import/jobs",              // POST create, GET list; /{id} get, /{id}/files, /{id}/answers, /{id}/commit, /{id}/rollback, /{id}/merge-exact
    'ONBOARDING_STATE': siteSetting.api.v2 + "onboarding/state"     // GET / PUT
}
